import { FolderOpen } from "lucide-react";

const SelectPanel = ({ panels, activePanel }) => {
  const selectedPanel = panels.filter((panel) => panel.id == activePanel)[0];
  if (!selectedPanel) {
    return (
      <div>
        <div className="w-8 h-8 bg-gray-700 rounded-full flex items-center justify-center mx-auto mb-2">
          <FolderOpen className="w-4 h-4 text-gray-500" />
        </div>
        <p className="text-xs text-gray-500">No saved files</p>
      </div>
    );
  }
  return (
    <>
      <div className="flex items-center justify-between mb-3 flex-shrink-0">
        <p className="text-sm text-gray-300">
          Total Files ({selectedPanel.totalCount})
        </p>
      </div>

      {selectedPanel.content ? (
        selectedPanel.content
      ) : (
        <div className="panel">{selectedPanel.label}</div>
      )}
    </>
  );
};
export default SelectPanel;
